<template>
    <div class="d-flex align-items-stretch">
        <parens left />
        <div
            v-bind:class="{ 'flex-column': wrap }"
            class="d-flex align-items-center">
            <component
                v-bind:is="formulaControl.childExpressionComponent"
                v-bind:child-binder="left" />
            <template v-if="wrap">
                <slot
                    v-if="hasStackedSlot"
                    name="stackedOperator" />
                <div
                    v-else
                    v-bind:class="operatorClass">
                    {{ operator }}
                </div>
            </template>
            <template v-else>
                <slot
                    v-if="hasInlineSlot"
                    name="inlineOperator" />
                <div
                    v-else
                    v-bind:class="operatorClass">
                    {{ operator }}
                </div>
            </template>
            <component
                v-bind:is="formulaControl.childExpressionComponent"
                v-bind:child-binder="right" />
        </div>
        <parens />
    </div>
</template>
<script>
    import base from "./_baseExpression.vue";
    export default {
        extends: base,
        props: {
            operator: { type: String, required: true },
            operatorIsText: { type: Boolean, required: false, default: false }
        },
        computed: {
            hasStackedSlot() {
                return Boolean(this.$slots.stackedOperator);
            },
            hasInlineSlot() {
                return Boolean(this.$slots.inlineOperator);
            },
            operatorClass() {
                if (this.operatorIsText) {
                    return this.textOperatorClassName;
                }
                return this.operatorClassName;
            },
            left() {
                return this.getChildBinderByIndex(0);
            },
            right() {
                return this.getChildBinderByIndex(1);
            }
        }
    };
</script>
